<template>
    <div>
        <div>
            <v-dialog persistent v-model="showStockModal" scrollable :max-width="Global.MODAL_WIDTH" @close="close">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text  class="mx-0, px-0">
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12 sm6 px-2>
                                    <v-autocomplete
                                        v-model="mForm.articleId"
                                        :items="articles"
                                        item-text="name"
                                        item-value="id"
                                        :disabled="stockShow"
                                        label="Produtos*"
                                        :error-messages="articleIdErrors"
                                        @blur="$v.mForm.articleId.$touch()"
                                    ></v-autocomplete>
                                </v-flex>

                                <v-flex xs12 sm6 md6 px-2>
                                    <v-text-field v-model="mForm.quantity"
                                          type="number"
                                          :error-messages="quantityErrors"
                                          @blur="$v.mForm.quantity.$touch()"
                                          :disabled="stockShow"
                                          label="Quantidade*"
                                          persistent-hint
                                          :hint="mForm.quantity > 0 ? 'Entrada' : mForm.quantity < 0 ? 'Saída' : ''"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 sm12 md12 px-2>
                                    <v-textarea v-model="mForm.description"
                                        :counter="$v.mForm.description.$params.maxLength.max"
                                        :error-messages="descriptionErrors"
                                        @blur="$v.mForm.description.$touch()"
                                        rows="3"
                                        outline
                                        :disabled="stockShow"
                                        label="Descrição*"
                                    ></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-container>

                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <div v-if="!loading_modal">
                            <v-btn depressed @click="close">Cancelar</v-btn>
                            <v-btn v-if="!stockShow" :disabled="$v.$invalid || mForm.quantity == 0" color="primary" @click="addStock()">Guardar</v-btn>
                        </div>
                        <v-progress-circular v-else indeterminate color="primary" m-2 ></v-progress-circular>
                    </v-card-actions>

                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
    import Vue from "vue";
    import _ from 'lodash';
    import {eventBus} from "../../main";
    import {mapGetters} from 'vuex';
    import {Model, Types, Global} from "../../config";
    import {maxLength, minLength, minValue, required, requiredIf, maxValue} from 'vuelidate/lib/validators';

    export default {
        name: "StockFormModal",

        beforeDestroy(){
            this.close();
        },

        data () {
            return {
                Global,
                Types,
                newContactName: '',
                active_tab: 0,
                loading_modal: false,

                mForm: {
                    articleId: null,
                    quantity: '',
                    description: '',
                },

                //company form modal needed attributes
                company_types: [],
                company_categories: [],
                // cities: [],

                //AutoComplete
                isLoading: false,
                searchCompanyField: null,

                loadingPayingInvoice: false,
            }
        },

        props: {
            articles: Array,
            simplifiedModal: {
                type: Boolean,
                default: false
            },
        },

        validations: {
            mForm: {
                articleId: {
                    required
                },
                quantity: {
                    required,
                },
                description: {
                    required,
                    maxLength: maxLength(1000),
                },
            },
        },

        watch: {
            showStockModal(){
                if(this.showStockModal){
                    this.onStockModalOpened();
                }
            },

        },

        methods: {

            onStockModalOpened(){
                if(!this.selectedStock){
                    // this.showStockModal = false;
                    return;
                }
                this.mForm.articleId = this.selectedStock.product_id;
                this.mForm.quantity = this.selectedStock.quantity;
                this.mForm.description = this.selectedStock.description;
            },

            addStock(){
                try{
                    this.loading_modal = true;
                    Vue.axios.post('stock', {
                        article_id: this.mForm.articleId,
                        quantity: this.mForm.quantity,
                        description: this.mForm.description,
                    })
                    .then(response => {
                        this.consoleLog(response);
                        if(!response.data.success){
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }

                        this.$emit('onStockFormDone');
                        this.showSnackBar('Movimento stock adicionado com sucesso', 'success');

                        this.close();

                    }).catch(error => {
                        this.consoleLog(error);
                        this.showSnackBar('Ocorreu um erro ao adicionar stock', 'error');
                    }).finally( ()=> {
                        this.loading_modal = false;
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao adicionar stock!', 'error');
                    this.loading_modal = false;
                }
            },

            resetForm(){
                this.mForm.articleId = '';
                this.mForm.quantity = '';
                this.mForm.description = '';
            },

            close () {
                this.showStockModal = false;
                this.newContactName = '';
                this.$v.$reset();
                this.resetForm();
                this.active_tab = 0;
                this.loadingPayingInvoice = false;

                setTimeout(() => {
                    // this.selectedIndex = -1;
                    // this.formClient = this.getNewCompany();
                    this.loading = false;
                    this.stockShow = false;
                }, 300);
            },

        },

        computed: {
            ...mapGetters([
                'loggedUser',
                'isLoggedUserSuperAdmin',
                'getToken'
            ]),
            showStockModal: {
                get(){
                    return this.$store.getters.getShowStockModal;
                },
                set(value){
                    this.$store.dispatch('setShowStockModal', value);
                }
            },
            selectedStock: {
                get(){
                    return this.$store.getters.getSelectedStock;
                },
                set(value){
                    this.$store.dispatch('setSelectedStock', value);
                }
            },
            stockShow: {
                get(){
                    return this.$store.getters.getStockShow;
                },
                set(value){
                    this.$store.dispatch('setStockShow', value);
                }
            },

            formTitle () {
                return this.stockShow ? 'Stock' : (this.selectedStock && this.selectedStock.id ? 'Editar Movimento Stock' : 'Novo  Movimento Stock');
            },
            articleIdErrors () {
                const errors = [];
                if (!this.$v.mForm.articleId.$dirty) return errors;
                !this.$v.mForm.articleId.required && errors.push('Obrigatório');
                return errors
            },
            quantityErrors () {
                const errors = [];
                if (!this.$v.mForm.quantity.$dirty) return errors;
                !this.$v.mForm.quantity.required && errors.push('Obrigatório');
                this.mForm.quantity == 0 && errors.push('Introduza um valor diferente de zero');
                return errors
            },
            descriptionErrors () {
                const errors = [];
                if (!this.$v.mForm.description.$dirty) return errors;
                !this.$v.mForm.description.required && errors.push('Obrigatório');
                !this.$v.mForm.description.maxLength && errors.push('Máximo de 1000 caracteres');
                return errors
            },

        },

    }
</script>

<style scoped>

</style>